import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'
import contestApi from '@/api/contest'

export default {
    name: 'ContestAreaInfo',
    components: {
        AppBar,
        AppBarSpace,
    },
    data() {
        return {
            contestId: this.$route.params.contestId,
            sessionNo: this.$route.query.session,
            subareaList:[],
            currentAreaInfo: this.$route.query.currentAreaInfo,
            keyword: null,
            searchResultList: null,
            currentSearchTimeOutId: null,
            playerContestInfo: null,
            showPlayerContestInfoPop: false,
            currentSubareaInfoList: null,
            showChangeSubarea: false,
            showInpoutScorePop: false,
            currentPlayerScoreItem:null,
            showPunishPop:false,
            currentPunishItem:null,
            isLoading:false,
            SortType:{
                noAsc:'noAsc',
                noDesc:'noDesc',
                resultAsc:'resultAsc',
                resultDesc:'resultDesc',
                scoreAsc:'scoreAsc',
                scoreDesc:'scoreDesc'

            },
            currentSortType:null,
        }
    },
    created() {
        this.subareaList.push({
            text:'第1区',
            value:1
        })
        this.currentSortType = this.SortType.noAsc
        this.getSubareaInfo()
    },
    methods: {
        onRefresh(){
            this.currentSortType = this.SortType.noAsc
            this.getSubareaInfo()
        },
        sort(sortType){
            if(this.currentSortType !== sortType){
                this.currentSortType = sortType
                this.getSubareaInfo()
            }
        },
        async getSubareaInfo() {
            try {
                this.currentSubareaInfoList = await contestApi.getSubareaInfo(this.contestId, this.sessionNo, this.currentAreaInfo.value,this.currentSortType);
                this.isLoading = false
                if(this.currentSubareaInfoList.subareaCount != null){
                    const subareaList = [];
                    for (let i = 1; i <= this.currentSubareaInfoList.subareaCount; i++) {
                        subareaList.push({
                            text:'第'+i+'区',
                            value:i
                        })
                    }
                    this.subareaList = subareaList
                }
            } catch (error) {
                this.isLoading = false
                this.$toast.fail(error.message)
            }
        },
        async search() {
            try {
                this.searchResultList = await contestApi.searchPlayer(this.keyword, this.contestId);
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        onKeyWordInput(value) {
            console.log(value.data + "   " + this.keyword)
            if (this.keyword === '' || this.keyword === null) {
                this.searchResultList = null
                return
            }
            if (this.currentSearchTimeOutId != null) {
                window.clearTimeout(this.currentSearchTimeOutId)
            }
            this.currentSearchTimeOutId = window.setTimeout(() => {
                this.search()
            }, 800)
        },
        clearKeyword() {
            this.keyword = null
            this.searchResultList = null
        },
        async showPlayerContestInfo(player) {
            this.$toast.loading()
            try {
                this.playerContestInfo = await contestApi.searchPlayerContestInfo(player.id);
                this.$set(this.playerContestInfo,'playerName',player.playerName)
                this.showPlayerContestInfoPop = true
                this.$toast.clear()
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        async showPlayerContestInfoById(playerId,playerName) {
            this.$toast.loading()
            try {
                this.playerContestInfo = await contestApi.searchPlayerContestInfo(playerId);
                this.$set(this.playerContestInfo,'playerName',playerName)
                this.showPlayerContestInfoPop = true
                this.$toast.clear()
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        onChangeSubarea() {
            this.$refs.ChangeSubareaPicker.confirm();
        },
        onChangeSubareaConfirm(value) {
            if (value.value !== this.currentAreaInfo.value) {
                this.currentAreaInfo = value
                this.getSubareaInfo()
            }
            this.showChangeSubarea = false
        },
        onInputScore(item) {
            this.showInpoutScorePop = true
            this.currentPlayerScoreItem = JSON.parse(JSON.stringify(item))
        },
        async onInputScoreConfirm() {
            this.showInpoutScorePop = false
            this.$toast.loading()
            try {
                // eslint-disable-next-line no-unused-vars
                const result = await contestApi.savePlayerScore(this.contestId, this.currentPlayerScoreItem.id, this.currentPlayerScoreItem.num, this.currentPlayerScoreItem.weight);
                this.currentPlayerScoreItem = null
                this.$toast.success('录入成功')
                this.getSubareaInfo()
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        async onProxyDraw(item) {
            this.$toast.loading()
            try {
                // eslint-disable-next-line no-unused-vars
                const result = await contestApi.proxyPlayerDraw(this.contestId,item.id);
                this.$toast.success('代抽签成功')
                this.getSubareaInfo()
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        onPunish(item) {
            this.showPunishPop = true
            this.currentPunishItem = {
                playerId:item.playerId,
                playerUserId:item.playerUserId,
                id:item.id,
                punishScore:null,
                punishRemark:null,
                subareaNo:item.subareaNo,
                playerName:item.playerName,
            }
        },
        async onPunishConfirm(){
            this.showPunishPop = false
            this.$toast.loading()
            try {
                // eslint-disable-next-line no-unused-vars
                const result = await contestApi.punishPlayerScore(this.contestId,this.currentPunishItem.id,this.currentPunishItem.playerId,this.currentPunishItem.punishRemark,this.currentPunishItem.punishScore);
                this.currentPunishItem = null
                this.$toast.success('处罚成功')
                this.getSubareaInfo()
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        jumpToRankInfo() {
            this.$router.push({path: '/my-contests/' + this.contestId + '/rank', query: {}})
        }

    }
}
